import { createApi, type Orientation } from "unsplash-js";
import type { Workers } from "../../utils/service-url";
import { type ApiResponse, useApiServiceCallback } from "./client";
import { WorkerApiService } from "./worker";

export class UnsplashService extends WorkerApiService {
  module = "unsplash" as const satisfies Workers;

  async search(
    query: string,
    orientation?: Orientation,
  ): Promise<
    ApiResponse<{
      photos: Awaited<ReturnType<ReturnType<typeof createApi>["search"]["getPhotos"]>>["response"];
    }>
  > {
    const settings = new URLSearchParams();
    settings.set("query", query);
    if (orientation) settings.set("orientation", orientation);

    return await this.get(`search?${settings.toString()}`);
  }

  async ackDownload(url: string): Promise<ApiResponse<{ success: boolean }>> {
    return await this.post("download", { url });
  }

  async getId(id: string): Promise<
    ApiResponse<{
      full: Awaited<ReturnType<ReturnType<typeof createApi>["photos"]["get"]>>["response"];
    }>
  > {
    return await this.get(`get/${id}`);
  }
}

export const useUnsplashSearch = (): ((
  query: string,
  orientation: Orientation,
) => Promise<
  ApiResponse<{
    photos: Awaited<ReturnType<ReturnType<typeof createApi>["search"]["getPhotos"]>>["response"];
  }>
>) => {
  return useApiServiceCallback(
    UnsplashService,
    async ({ apiService }, query: string, orientation: Orientation) =>
      await apiService.search(query, orientation),
    [],
  );
};
